import React from 'react';
import { Checkbox, Divider } from '@material-ui/core';
import { formatPrice } from '@rcg/pricing-format';
import useStyles from './index.style';
import Dictionary from '../../../../utils/dictionary';
import useDictionary from '../../../../hooks/useDictionary';

const CancellationTable = ({
  guestInformation,
  currency,
  handleCancellation,
  totalAirCharges,
  totalAirPenalty,
  cancellationGuests,
}) => {
  const classes = useStyles();
  const getDictionaryValue = useDictionary(Dictionary);

  const selectGuest = (guest) => {
    handleCancellation(guest);
  };

  const preformatPrice = (amount) => {
    return formatPrice(amount, currency, true, true, false);
  };

  const finalAmmount = (airCharges, airPenalty) => {
    let price = airCharges - airPenalty;

    if (price >= 0) {
      return `${preformatPrice(price)} ${currency}`;
    }
    price = Math.abs(price);
    return `-${preformatPrice(price)} ${currency}`;
  };

  return (
    <div className={classes.cancelationTable}>
      <ul>
        <li className="table-title">
          <span> {getDictionaryValue(Dictionary.airCancellationTableGuestLabel.key)} </span>
          <span className="flight-cost">
            {getDictionaryValue(Dictionary.airCancellationTableCostLabel.key)}
          </span>
          <span>{getDictionaryValue(Dictionary.airCancellationTableChargesLabel.key)}</span>
        </li>
        {guestInformation?.map((guest) => {
          const {
            flightGuest: { firstName, lastName, airChargesAmount, airPenaltyAmount },
            id,
          } = guest;

          const fullName = `${firstName} ${lastName}`;
          return (
            <li key={id} className="row-item">
              <Checkbox
                color="primary"
                size="medium"
                className="cancellation-check"
                inputProps={{ 'aria-label': 'cancellation checkbox' }}
                onChange={() =>
                  selectGuest({
                    firstName,
                    lastName,
                    guestId: id,
                    airChargesAmount,
                    airPenaltyAmount,
                  })
                }
                name={id}
                checked={cancellationGuests?.some((selectedGuest) => selectedGuest.guestId === id)}
              />
              <div className="guest-info">
                <span>{fullName.toLocaleLowerCase()}</span>
                <span>
                  {`${getDictionaryValue(
                    Dictionary.airCancellationTableCostLabel.key,
                  )} ${preformatPrice(airChargesAmount)}`}
                </span>
              </div>
              <div className="flight-cost">{preformatPrice(airChargesAmount)}</div>
              <div className="price">
                <span>{preformatPrice(airPenaltyAmount)}</span>
              </div>
            </li>
          );
        })}
      </ul>
      {Boolean(totalAirCharges || totalAirPenalty) && (
        <>
          <Divider className="divider-separator" />
          <div className="summary-container">
            <p className="summary-title" data-testid="summary-section">
              {getDictionaryValue(Dictionary.airCancellationSummaryTitle.key)}
            </p>
            <div>
              <div className="summary-cost">
                <p> {getDictionaryValue(Dictionary.airCancellationSummaryFlightCost.key)}</p>
                <p>-{preformatPrice(totalAirCharges)}</p>
              </div>
              <div className="summary-cost">
                <p> {getDictionaryValue(Dictionary.airCancellationSummaryCancellationFee.key)}</p>
                <p>{preformatPrice(totalAirPenalty)}</p>
              </div>
              <div className="total-cost">
                <p>{getDictionaryValue(Dictionary.airCancellationSummaryTotalFlightRefund.key)}</p>
                <p data-testid="total-charges">{finalAmmount(totalAirCharges, totalAirPenalty)}</p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CancellationTable;
